module.exports = __webpack_public_path__ + "img/vsim.f68710d8.png";